import { trackEvent } from './track-event'

export function trackOpenChangeWishlist() {
  trackEvent({
    event: 'view_wishlist_modal',
    event_name: 'user_interaction',
    action: 'click - change_wishlist',
  })
}
